<h3 i18n="@@flexible-delivery" class="flexibleDelivery">{{fulfilmentMethodLabel}}</h3>
<h5 i18n="@@pricing" class="pricing">Pricing</h5>

<div class="flexibleDeliveryFee">
    <span i18n="@@countdown-now-heading" class="heading">{{flexibleDeliveryPriceLabel}}</span>
    <span i18n="@@countdown-now-price" class="price">{{flexibleDeliveryFee | currency}}</span>
</div>

<div class="bagFee">
    <span i18n="@@countdown-now-heading" class="bagFee-heading">Bag charge</span>
    <span i18n="@@countdown-now-price" class="bagFee-price">$1.50</span>
</div>

<div class="minimumCharge">
    <span i18n="@@countdown-now-heading" class="minimumCharge-heading">Minimum order value</span>
    <span i18n="@@countdown-now-price" class="minimumCharge-price">{{minimumOrderCharge | currency}}</span>
</div>

<div class="orderSize" *ngIf="getItemsLimit()">
    <h5 i18n="@@countdown-now-order-size" class="orderSize-heading">Order size</h5>
    <span i18n="@@countdown-now-order-size-message">{{flexibleDeliveryPriceLabel}} orders are limited to
        {{getItemsLimit()}} items per order</span>
</div>

<div class="deliveryMethod">
    <h5 i18n="@@countdown-now-delivery-method" class="deliveryMethodHeading">Delivery method</h5>
    <ul>
        <li i18n="@@countdown-now-delivery-partners">{{fulfilmentMethodLabel}} are handled by our Partner Drivers</li>
        <li i18n="@@countdown-now-delivery-tracking">You will get an SMS with live tracking when your order is on the way</li>
    </ul>
</div>

<div class="restrictions">
    <h5 i18n="@@countdown-now-availability" class="restrictionsHeading">Restricted items</h5>
    <span i18n="@@countdown-now-restrictions-message">Restricted products like alcohol or tobacco are not available for
        delivery with {{fulfilmentMethodLabel}}</span>
</div>